///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { Directive, Input } from '@angular/core';

@Directive({
    standalone: false
})
export abstract class GtthEntityInfoWindowContent {
    @Input()
    entityId: number;
    forceClose: boolean;

    abstract isValid(): boolean;
}
